module.exports = __webpack_public_path__ + "static/media/small-Logo.c52eb1a3.svg";